module.exports = __webpack_public_path__ + "img/no-camera.2ea39fe6.svg";